import React from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import PasswordForm from '../../components/profile/PasswordForm';
import DeleteAccount from '../../components/profile/DeleteAccount';
import { useProfile } from '../../hooks/useProfile';
import { theme } from '../../config/theme';

const CustomerSettings = () => {
  const { changePassword, loading } = useProfile();

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold, 
          marginBottom: theme.spacing.xl 
        }}>
          Settings
        </h1>
        <div style={{ marginBottom: theme.spacing.xl }}>
          <PasswordForm onSubmit={changePassword} loading={loading} />
        </div>

        <DeleteAccount />
      </div>
    </MainLayout>
  );
};

export default CustomerSettings;